import { useTranslation } from 'react-i18next';
import BasicCard from '../basicCard/BasicCard';
import dayjs from 'dayjs';

import { SessionSummaryProps } from '../../types/priceTypes';
const SessionSummary: React.FC<SessionSummaryProps> = ({
  date,
  typeOfPosition,
  establishment,
  establishmentOther,
  products,
}) => {
  const { t } = useTranslation('price');

  return (
    <div className="my-4 ml-0 rounded-lg xl:ml-4">
      <BasicCard>
        <div className="p-4">
          <h2 className="text-lg font-bold text-black md:text-xl mb-4">{t('sessionSummaryHeading')}</h2>
          <div className="md:text-md space-y-2 text-sm md:space-y-4">
            <div className="space-y-2">
              <p className="font-bold">{t('dateLabel')}</p>
              <p>{dayjs(date).format('YYYY-MM-DD')}</p>
            </div>
            <div className="space-y-2">
              <p className="text-md font-bold">{t('typeOfPositionLabel')}</p>
              <p className="break-words">
                {typeOfPosition
                  ? typeOfPosition
                  : ''}
              </p>
            </div>
            <div className="space-y-2">
              <p className="text-md font-bold">{t('establishmentLabel')}</p>
              <p className="break-words">{establishment}</p>
              {establishmentOther && <p className="break-words">{establishmentOther}</p>}
            </div>
            <div className="space-y-2">
              <p className="text-md font-bold">{t('products')}</p>
              <p>{products.length}</p>
            </div>
          </div>
        </div>
      </BasicCard>
    </div>
  );
};

export default SessionSummary;
